<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-card *ngIf="!EstCharge()">
  <div class="fluid formgrid grid">
    <div class="flex flex-column gap-2 my-2 col-12 text-center">
      <p-progressSpinner></p-progressSpinner>
    </div>
  </div>
</p-card>

<div *ngIf="EstCharge()" class="grid">
  <div class="col-12">
    <p-card>
      <h5>{{actionCorrective.numero}}
        <!-- <span [class]="'statut ' + actionCorrective.statut.nom.toLowerCase()">
          {{actionCorrective.statut.nom}}
        </span> -->
      </h5>

      <p-menubar [model]="menu" [autoDisplay]="false">
        <p-button *ngIf="modeConsultation()" (click)="Modifier()" icon="pi pi-pencil"
          styleClass="p-button-primary"></p-button>
        <p-button *ngIf="modeModification()" (onClick)="enregistrerModifications()" label icon="pi pi-check"
          styleClass="p-button-success mr-2">
        </p-button>
        <p-button *ngIf="modeModification()" (onClick)="Consulter()" icon="pi pi-times"
          styleClass="p-button-secondary"></p-button>
      </p-menubar>
    </p-card>
  </div>
</div>

<div *ngIf="EstCharge()" class="grid">
  <div class="col-12">
    <p-card>
      <p-tabView [scrollable]="true" #tabView [(activeIndex)]="tabIndex" (onChange)="surChangementOnglet($event)">
        <p-tabPanel header="Informations générales" leftIcon="pi pi-info-circle">
            <div class="flex flex-column gap-2 my-2">
              <label for="nonConformite">Non-conformité</label>
              <p-inputGroup>
                <input type="text" pInputText [value]="actionCorrective.nonConformite.numero + ' - ' + actionCorrective.nonConformite.titre" readonly />
                <p-button icon="pi pi-eye" label="Voir" [outlined]="true" (click)="voirNonConformite()" />
              </p-inputGroup>
            </div>

          <div class="flex flex-column gap-2 my-2">
            <label for="demande">Description<span class="requis">*</span></label>
            <sihc-quill-view *ngIf="modeConsultation()" [modules]="sdb.modules" [content]="actionCorrective.demande"
              [style]="{'min-height': '100px !important', 'max-height': '300px', 'overflow': 'hidden', 'overflow-y': 'scroll', 'border': '1px solid #ccc', 'border-radius': '5px' }"></sihc-quill-view>
            <p-editor *ngIf="!modeConsultation()" [(ngModel)]="actionCorrective.demande" [readonly]="modeConsultation()" [formats]="sdb.formats"
              [modules]="sdb.modules" [placeholder]="'Décrivez l\'action corrective...'"
              (onSelectionChange)="surModification($event)" [style]="{ height: '320px', width: '100%' }" />
            <small class="p-error" *ngIf="submitted && !actionCorrective.demande">La description est
              obligatoire.</small>
          </div>

          <div class="flex flex-column gap-2 my-2">
            <label for="date">Date cible<span class="requis">*</span></label>
            <p-calendar *ngIf="modeModification()" [(ngModel)]="actionCorrective.dateCible" dateFormat="yy-mm-dd"
              [showIcon]="true"></p-calendar>
            <input *ngIf="modeConsultation()" id="dateCible" type="text" pInputText
              value="{{actionCorrective.dateCible | date:'yyyy-MM-dd'}}" [readOnly]="true">
            <small class="p-error" *ngIf="submitted && !actionCorrective.dateCible">La date cible est
              obligatoire.</small>
          </div>

          <p-divider styleClass="mt-5">
            <i class="pi pi-check-circle mr-2"></i>
            <span class="font-bold">Vérifications</span>
          </p-divider>

          <div class="flex flex-column gap-2 my-4">
            <label for="verifMiseEnOeuvre">Vérification de la mise en oeuvre</label>
            <sihc-quill-view *ngIf="modeConsultation()" [modules]="sdb.modules" [content]="actionCorrective.verifMiseEnOeuvre"
              [style]="{'min-height': '100px !important', 'max-height': '300px', 'overflow': 'hidden', 'overflow-y': 'scroll', 'border': '1px solid #ccc', 'border-radius': '5px' }"></sihc-quill-view>
            <p-editor *ngIf="!modeConsultation()" [(ngModel)]="actionCorrective.verifMiseEnOeuvre" [readonly]="modeConsultation()" [formats]="sdb.formats" [modules]="sdb.modules" [placeholder]="'Décrivez la vérification de la mise en oeuvre...'" (onSelectionChange)="surModification($event)" [style]="{ height: '320px', width: '100%' }" />
            <label for="dateCibleMiseEnOeuvre">Date cible de la vérification de la mise en oeuvre</label>
            <p-calendar *ngIf="modeModification()" [(ngModel)]="actionCorrective.dateCibleMiseEnOeuvre" dateFormat="yy-mm-dd"
              [showIcon]="true"></p-calendar>
            <input *ngIf="modeConsultation()" id="dateCibleMiseEnOeuvre" type="text" pInputText
              value="{{actionCorrective.dateCibleMiseEnOeuvre | date:'yyyy-MM-dd'}}" [readOnly]="true">
          </div>

          <div class="flex flex-column gap-2 my-4">
            <label for="verifEfficacite">Vérification de l'efficacité</label>
            <sihc-quill-view *ngIf="modeConsultation()" [modules]="sdb.modules" [content]="actionCorrective.verifEfficacite"
              [style]="{'min-height': '100px !important', 'max-height': '300px', 'overflow': 'hidden', 'overflow-y': 'scroll', 'border': '1px solid #ccc', 'border-radius': '5px' }"></sihc-quill-view>
            <p-editor *ngIf="!modeConsultation()" [(ngModel)]="actionCorrective.verifEfficacite" [readonly]="modeConsultation()" [formats]="sdb.formats" [modules]="sdb.modules" [placeholder]="'Décrivez la vérification de l\'efficacité...'" (onSelectionChange)="surModification($event)" [style]="{ height: '320px', width: '100%' }" />
            <label for="dateCibleEfficacite">Date cible de la vérification de l'efficacité</label>
            <p-calendar *ngIf="modeModification()" [(ngModel)]="actionCorrective.dateCibleEfficacite" dateFormat="yy-mm-dd"
              [showIcon]="true"></p-calendar>
            <input *ngIf="modeConsultation()" id="dateCibleEfficacite" type="text" pInputText
              value="{{actionCorrective.dateCibleEfficacite | date:'yyyy-MM-dd'}}" [readOnly]="true">
          </div>
        </p-tabPanel>


        <p-tabPanel [header]="'Suivi (' + (actionCorrective.nbSuivis ?? 0) + ')'" leftIcon="pi pi-comments">
          <ng-template pTemplate="content">
            <app-fil-conversation [conversationId]="actionCorrective.conversationId"></app-fil-conversation>
          </ng-template>
        </p-tabPanel>


        <p-tabPanel [header]="'Documents (' + (actionCorrective.nbDocuments ?? 0) + ')'" leftIcon="pi pi-file">
          <ng-template pTemplate="content">
            <p-messages severity="info">
              <ng-template pTemplate>
                <i class="pi pi-info-circle"></i>
                <div class="ml-2">Documents liés à la non-conformité associée</div>
              </ng-template>
            </p-messages>
            <app-document [typeLienDocument]="ETypeLienDocument.NonConformite"
              [idLien]="actionCorrective.nonConformite.idNonConformite" [selectedTreeNode]="typeDocumentSelectionne"
              [numero]="actionCorrective.nonConformite.numero"></app-document>
          </ng-template>
        </p-tabPanel>
      </p-tabView>
    </p-card>
  </div>
</div>